import MenuItem from '../MenuItem/MenuItem';
import './MenuCategory.css';

function MenuCategory({ category, items }) {
  return (
    <div className="menu-category">
      <h2 className="menu-category__title">{category}</h2>
      <div className="menu-category__divider"></div>
      <div className="menu-category__items">
        {items.map((item, index) => (
          <MenuItem key={index} {...item} />
        ))}
      </div>
    </div>
  );
}

export default MenuCategory;
